"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Airgram_1 = require("./Airgram");
exports.Airgram = Airgram_1.Airgram;
var components_1 = require("./components");
exports.Composer = components_1.Composer;
exports.TDLibError = components_1.TDLibError;
exports.TdProvider = components_1.TdProvider;
var utils_1 = require("./utils");
exports.isError = utils_1.isError;
exports.toObject = utils_1.toObject;
exports.on = utils_1.on;
